import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  TEALIUM_PAGE_CLASSIFY,
  TEALIUM_PAGE_CREATE,
  TEALIUM_PAGE_EDIT,
  TEALIUM_PAGE_EDIT_PAY_AND_POST,
  TEALIUM_PAGE_PAY_AND_POST,
  TEALIUM_PAGE_REFRESH,
  TEALIUM_PAGE_REFRESH_ERROR,
  TEALIUM_PAGE_SUCCESS,
} from 'src/app/analytics';
import { getTrackerSelector } from 'src/app/dataAnalytics/utils/getTrackerSelector';
import { sendPageTracking } from 'src/app/dataAnalytics/utils/sendPageTracking';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';

import { otherPagesSelector } from '../selectors/otherPagesSelector';

const selector = getTrackerSelector(otherPagesSelector);

const pagesToExclude = [
  TEALIUM_PAGE_CREATE,
  TEALIUM_PAGE_CLASSIFY,
  TEALIUM_PAGE_PAY_AND_POST,
  TEALIUM_PAGE_SUCCESS,
  TEALIUM_PAGE_EDIT,
  TEALIUM_PAGE_EDIT_PAY_AND_POST,
  TEALIUM_PAGE_REFRESH,
  TEALIUM_PAGE_REFRESH_ERROR,
];
export const OtherPagesTracker = () => {
  const { page, hasHirerInfo, isPageReady, isDataCleanUpComplete } =
    useSelector(selector);
  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  useEffect(() => {
    if (
      page &&
      isPageReady &&
      hasHirerInfo &&
      isDataCleanUpComplete &&
      !pagesToExclude.includes(page)
    ) {
      sendPageTracking(page, isPageAnalyticsEnabled);
    }
  }, [
    isPageAnalyticsEnabled,
    page,
    isPageReady,
    hasHirerInfo,
    isDataCleanUpComplete,
  ]);
  return <></>;
};
